import * as Business from '../business';
import * as User     from '../user';
import MenuButton    from './menu_button';
import MenuOverlay   from './menu_overlay';
import MenuPanel     from './menu_panel';
import React         from 'react';
import useBoolean    from '../hooks/use_boolean';


export default function Menu({ tab, businessID, navigateTo }) {

  const business        = Business.useBusiness(businessID);
  const userName        = User.useUserName();
  const locations       = User.useLocations();
  const needsOnboarding = Business.useNeedsOnboarding(businessID);

  const [ menuIsOpen, openMenu, closeMenu, toggleMenu ] = useBoolean(false);

  const isMultipleLocation                 = locations?.length > 0;
  const haveSomeLocationCompleteOnboarding = isMultipleLocation && locations.some(({ onboarding }) => onboarding?.status !== 'pending');
  const shouldShowMenu                     = !needsOnboarding || (needsOnboarding && haveSomeLocationCompleteOnboarding);

  if (shouldShowMenu) {
    return (
      <>
        <MenuOverlay {...{ closeMenu }}/>
        <MenuPanel {...{ tab, businessID, navigateTo, userName, business, locations, closeMenu, needsOnboarding }}/>
        <MenuButton {...{ menuIsOpen, openMenu, closeMenu, toggleMenu }}/>
      </>
    );
  } else
    return null;
}
